import {Platform, Pressable} from "react-native";
import styled from "styled-components";
import {Column, Columns, Stack, Text, View} from "@unibuddy/patron";

import {Attachment} from "ubcommunity-shared/src/types";
import {boldFontStyles} from "ubcommunity-shared/src/Styles/fontStyles";

import {convertToMb} from "../useAttachments";
import PdfIcon from "./PdfIcon";
import {DownloadButton} from "./FileDownloadButton";

type Props = {
    files: Attachment[];
    onPreview: (file: Attachment) => void;
    onLongPress: () => void;
};

const Container = styled(View)`
    transition: 0.2s ease-in-out;
    &:hover {
        background-color: ${({theme}) => theme?.colors?.groupBgColor};
    }
`;

export const FileThumbnail = ({files, onPreview, onLongPress}: Props) => {
    return (
        <Stack space="small">
            {files.map((file) => (
                <Container
                    position="relative"
                    overflow="hidden"
                    borderRadius="xsmall"
                    borderWidth={1}
                    borderColor="#D0D9D9"
                    padding="small"
                    justifyContent="center"
                    w={260}
                    h={72}
                    key={file.fileName}
                    bgColor="white"
                    {...Platform.select({
                        native: {
                            width: "100%",
                        },
                    })}
                >
                    <Pressable
                        onLongPress={onLongPress}
                        onPress={() => onPreview(file)}
                        accessibilityLabel={`Preview file ${file.fileName}`}
                        accessibilityRole="button"
                    >
                        <Columns verticalAlign="center">
                            <Column width="content">
                                <PdfIcon />
                            </Column>
                            <Column>
                                <View paddingX="small">
                                    <Stack space="small">
                                        <Text
                                            truncate
                                            size="medium"
                                            {...{style: {...boldFontStyles}}}
                                            numberOfLines={1}
                                        >
                                            {file.fileName}
                                        </Text>
                                        <View>
                                            <Text color="altTextColor" size="small">
                                                {convertToMb(parseFloat(file.size ?? "0"))} MB
                                            </Text>
                                        </View>
                                    </Stack>
                                </View>
                            </Column>
                            <Column width="content">
                                <View>
                                    <DownloadButton ghost file={file} />
                                </View>
                            </Column>
                        </Columns>
                    </Pressable>
                </Container>
            ))}
        </Stack>
    );
};
